import React from "react";
import PropTypes from "prop-types";
import { RichText } from "prismic-reactjs";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import style from "./style";
import CustomLink from "../../components/CustomLink";
import Countdown, { zeroPad } from "react-countdown-now";
import Container from "@material-ui/core/Container";

const EventDetailsHero = ({ classes, eventHeroData }) => {
  const divStyle = {};
  if (eventHeroData.data.featured_image) {
    divStyle.backgroundImage = `url('${eventHeroData.data.featured_image.url}')`;
  }
  const Completionist = () => <div className={classes.completion}></div>;

  // Renderer callback with condition
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    } else {
      return (
        <>
          {zeroPad(days)} Days / {zeroPad(hours)} Hours / {zeroPad(minutes)}{" "}
          Minutes / {zeroPad(seconds)} Seconds
        </>
      );
    }
  };
  return (
    <div className={classes.background} style={divStyle}>
      <div className={classes.backgroundOverlay}>
        <Grid container direction="column" justify="center" alignItems="center">
          <Typography variant="h1" className={classes.preTitle}>
            {RichText.asText(eventHeroData.data.title)}
          </Typography>

          <Typography variant="h1" className={classes.heroTitle}>
            {RichText.asText(eventHeroData.data.subtitle1)}
          </Typography>

          <Typography variant="h1" className={classes.heroSubTitle}>
            {RichText.asText(eventHeroData.data.subtitle2)}
          </Typography>
          {eventHeroData.data.register_button_link?.url &&
            <div className={classes.heroButton}>
              {!eventHeroData.data.upcoming_or_past && (
                <CustomLink link={eventHeroData.data.register_button_link}>
                  <Button variant="contained" color="primary">
                    {RichText.asText(eventHeroData.data.register_button_text)}
                  </Button>
                </CustomLink>
              )}
            </div>
          }
        </Grid>
        {!eventHeroData.data.upcoming_or_past && (
          <div className={classes.eventDaysTime}>
            <Countdown
              zeroPadTime={2}
              date={eventHeroData.data.event_time_date_countdown}
              renderer={renderer}
            />
          </div>
        )}
      </div>
    </div>
  );
};

EventDetailsHero.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(style)(EventDetailsHero);
